import { Injectable } from "@angular/core";
import * as moment from "jalali-moment";
import * as Moment from "moment";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GroupByPipe } from "projects/sepidz-web-framework/src/lib/pipes/group-by.pipe";
import { MapObjectPipe } from "projects/sepidz-web-framework/src/lib/pipes/mapobject.pipe";
import { PersianService } from "projects/sepidz-web-framework/src/lib/services/persian.service";
import { take } from "rxjs/operators";
import { Branch } from "projects/sepidz-web-framework/src/lib/models";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { ClearEnum, DeliveryEnum, MealEnum } from "../../catalog/model/deposit.enum";
import { Personnel, PersonnelRolesCodeEnum } from "../../parties/model/personnel.model";
import { PrintPolicy, PrintPolicyPrintTimeEnum } from "../../prints/model/print-policy.model";
import { PrintTemplate } from "../../prints/model/print-template.model";
import { DeliveryCustomerPrintTime, SaleMethodNature } from "../../sales/model/sale-method-branch.model";
import { ChangeCachEnum } from "../model/changecach.enum";
import { Invoice, InvoiceCommand, InvoiceStatus } from "../model/invoice.model";
import { InvoiceItemPrintModel, InvoicePrintModel, PrintDocumentInvoiceModel } from "../model/InvoicePrintModel";
import { OrderService } from "../order.service";
import { TabletPosService } from "./tabletpos.service";
import { OrderItemCategory } from "../model/orderItemcategory.model";
import { HttpHeaders } from "@angular/common/http";
import { isNullOrEmptyString } from "@progress/kendo-angular-grid/dist/es2015/utils";

@Injectable({
  providedIn: "root",
})
export class InvoicePrintService extends BaseService {
  PrintPolicy: PrintPolicy[];
  currentBranch: Branch;
  PrintTemplate: PrintTemplate[];
  changeCachEnum: any[] = [];
  currentInvoiceList: InvoicePrintModel[] = [];
  HasLocalPrint: boolean = false;
  ComputerName: string;
  PrintPolicyForTotalPrice: any;
  currentUserPhoneNumber: string;
  DataDaysWeek = [
    { Id: 0, Title: this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.Saturday") },
    { Id: 1, Title: this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.Sunday") },
    { Id: 2, Title: this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.Monday") },
    { Id: 3, Title: this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.Tuesday") },
    { Id: 4, Title: this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.Wednesday") },
    { Id: 5, Title: this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.Thursday") },
    { Id: 6, Title: this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.Friday") },
  ];
  itemCategoryListAll: OrderItemCategory = null;
  constructor(private tabletPos: TabletPosService, private order: OrderService, private persianService: PersianService) {
    super();
  }
  checkForHasLocalPrint(): boolean {
    if (!this.ComputerName) {
      const computerName: string = this.storage.getData(ClearableCache.ComputerName);
      this.ComputerName = computerName;
    }
    this.HasLocalPrint = this.PrintPolicy?.some(
      (s) =>
        !isNullOrEmptyString(s.ComputerName) &&
        !isNullOrEmptyString(this.ComputerName) &&
        s.ComputerName?.replace(".local", "") === this.ComputerName?.replace(".local", "") &&
        s.HasLocalSetting
    );
    return this.HasLocalPrint;
  }
  async PreData() {
    const printPolicyData = this.order.storage.getData(ClearableCache.PrintPolicy);
    const printTemplateData = this.order.storage.getData(ClearableCache.PrintTemplate);
    if (this.changeCachEnum.some((f) => f === ChangeCachEnum.ItemcategoryList) && printPolicyData?.length) this.PrintPolicy = printPolicyData;
    else {
      const computerName = this.order.storage.getData(ClearableCache.ComputerName);
      this.httpCommonService
        .get("PrintPolicy/GetAllPrintPolicy" + (computerName ? "?ComputerName=" + computerName : ""))
        .pipe(take(1))
        .subscribe(
          (res: PrintPolicy[]) => {
            if (this.currentBranch.AccessToAllBranches) {
              this.PrintPolicy = res;
              this.order.storage.savePermanentData(this.PrintPolicy, ClearableCache.PrintPolicy);
            } else {
              this.PrintPolicy = res?.filter((f) => f.BranchId === this.currentBranch.Id);
              this.order.storage.savePermanentData(this.PrintPolicy, ClearableCache.PrintPolicy);
            }
          },
          (err) => {
            console.log(err);
          }
        );
    }
    this.checkForHasLocalPrint();
    /// PrintTemplate
    if (this.changeCachEnum.some((f) => f === ChangeCachEnum.PrintTemplate) && printTemplateData?.length) this.PrintTemplate = printTemplateData;
    else {
      this.httpCommonService
        .get("PrintTemplate")
        .pipe(take(1))
        .subscribe((res: PrintTemplate[]) => {
          this.PrintTemplate = res;
          this.order.storage.savePermanentData(this.PrintTemplate, ClearableCache.PrintTemplate);
        });
    }
  }
  async PrintLocalInvoice(invoice: Invoice, hasSelfPrint: boolean = false, withPrint: boolean = false): Promise<PrintDocumentInvoiceModel[]> {
    let printDocuments: PrintDocumentInvoiceModel[] = [];
    this.currentUserPhoneNumber = invoice.createdUserPhoneNUmber;
    const model = Object.assign({}, invoice);
    const allowPrint = invoice.CommandCode === InvoiceCommand.PosPayment || invoice.CommandCode === InvoiceCommand.TabletPos ? false : true;
    const InvoiceList: Invoice[] = [];
    let invoiceModel = null;
    /// fastfood
    if (
      model.SaleMethodNatureCode == SaleMethodNature.FastFood &&
      model.CommandCode != InvoiceCommand.Save &&
      model.CommandCode != InvoiceCommand.TemporaryRegister &&
      model.CommandCode != InvoiceCommand.ClearWithoutPrint
    ) {
      if (!allowPrint) return;
      if (model.CommandCode == InvoiceCommand.Clear && model.StatusCode == InvoiceStatus.Cleared) {
        if (!model.OldSaleMethodBranchId) {
          invoiceModel = Object.assign({}, model);
          invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.CustomerPrint;
          await this.PrintLocal(invoiceModel).then((res) => {
            if (res != null && res.length > 0) printDocuments.push(...res);
            invoice.CustomerPrintCount++;
          });
          invoiceModel = Object.assign({}, model);
          invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.PreparationPrint;
          await this.PrintLocal(invoiceModel).then((res) => {
            if (res != null && res.length > 0) printDocuments.push(...res);
            invoice.PreparationPrintCount++;
          });
        } else {
          invoiceModel = Object.assign({}, model);
          invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.CustomerPrint;
          await this.PrintLocal(invoiceModel).then((res) => {
            if (res != null && res.length > 0) printDocuments.push(...res);
            invoice.CustomerPrintCount++;
          });
        }
      }
      if (model.CommandCode == InvoiceCommand.CustomerPrint || model.CommandCode == InvoiceCommand.ReprintForCustomer) {
        invoiceModel = Object.assign({}, model);
        invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.CustomerPrint;
        await this.PrintLocal(invoiceModel).then((res) => {
          if (res != null && res.length > 0) printDocuments.push(...res);
          invoice.CustomerPrintCount++;
        });
      }
      if (
        ((model.CommandCode === InvoiceCommand.PreparationPrint || model.CommandCode === InvoiceCommand.ReprintForPreparation) &&
          (!model.OldSaleMethodBranchId || model.HasChange || model.CommandCode === InvoiceCommand.ReprintForPreparation)) ||
        (model.OldSaleMethodBranchId && model.OldStatusCode === InvoiceStatus.New)
      ) {
        invoiceModel = Object.assign({}, model);
        invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.PreparationPrint;
        await this.PrintLocal(invoiceModel).then((res) => {
          if (res != null && res.length > 0) printDocuments.push(...res);
          invoice.PreparationPrintCount++;
        });
      }
    }
    /// salon
    if (
      model.SaleMethodNatureCode == SaleMethodNature.Restaurant &&
      model.CommandCode != InvoiceCommand.Save &&
      model.CommandCode != InvoiceCommand.TemporaryRegister
    ) {
      if (!allowPrint && model.CommandCode != InvoiceCommand.CustomerPrint) return;
      if (
        (model.OldStatusCode == InvoiceStatus.Ordering && model.HasChange && !model.OldSaleMethodBranchId) ||
        model.CommandCode == InvoiceCommand.PreparationPrint ||
        model.CommandCode == InvoiceCommand.ReprintForPreparation
      ) {
        if (
          ((model.StatusCode != InvoiceStatus.Cleared && model.CustomerPrintCount <= 1) ||
            model.CommandCode == InvoiceCommand.ReprintForPreparation) &&
          (model.OldSaleMethodBranchId == null ||
            model.OldStatusCode === InvoiceStatus.New ||
            model.CommandCode == InvoiceCommand.ReprintForPreparation)
        ) {
          invoiceModel = Object.assign({}, model);
          invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.PreparationPrint;
          await this.PrintLocal(invoiceModel).then((res) => {
            if (res != null && res.length > 0) printDocuments.push(...res);
            invoice.PreparationPrintCount++;
          });
        }
      }
      if (
        model.CommandCode == InvoiceCommand.CustomerPrint ||
        model.CommandCode == InvoiceCommand.Clear ||
        model.CommandCode == InvoiceCommand.ReprintForCustomer
      ) {
        if (
          model.CommandCode === InvoiceCommand.ReprintForCustomer ||
          model.OldSaleMethodBranchId ||
          ((model.OldStatusCode === InvoiceStatus.Clearing || model.OldStatusCode === InvoiceStatus.Ordering) &&
            (model.HasChange ||
              (model.CustomerPrintCount <= 1 && model.CommandCode !== InvoiceCommand.Clear) ||
              (model.CustomerPrintCount < 1 && model.CommandCode === InvoiceCommand.Clear)))
        ) {
          invoiceModel = Object.assign({}, model);
          invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.CustomerPrint;
          await this.PrintLocal(invoiceModel).then((res) => {
            if (res != null && res.length > 0) printDocuments.push(...res);
            invoice.CustomerPrintCount++;
          });
        }
      }
    }
    /// Moshtarekin
    if (
      model.SaleMethodNatureCode == SaleMethodNature.Delivery &&
      model.CommandCode != InvoiceCommand.Save &&
      model.CommandCode != InvoiceCommand.TemporaryRegister
    ) {
      if (
        model.CommandCode == InvoiceCommand.ReceiptPrint ||
        model.CommandCode == InvoiceCommand.CustomerPrint ||
        model.CommandCode == InvoiceCommand.ReprintForCustomer ||
        (model.CommandCode == InvoiceCommand.Assign && model.DeliveryCustomerPrintTimeCode == DeliveryCustomerPrintTime.Assign) ||
        (model.CommandCode == InvoiceCommand.PreparationPrint && model.DeliveryCustomerPrintTimeCode == DeliveryCustomerPrintTime.PreparationPrint)
      ) {
        invoiceModel = Object.assign({}, model);
        invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.CustomerPrint;
        await this.PrintLocal(invoiceModel).then((res) => {
          if (res != null && res.length > 0) printDocuments.push(...res);
          invoice.CustomerPrintCount++;
        });
      }
      if (
        model.CommandCode == InvoiceCommand.PreparationPrint ||
        (model.IsMultiPrint && model.CommandCode == InvoiceCommand.TemporaryRegister) ||
        model.CommandCode == InvoiceCommand.ReprintForPreparation
      ) {
        invoiceModel = Object.assign({}, model);
        invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.PreparationPrint;
        await this.PrintLocal(invoiceModel).then((res) => {
          if (res != null && res.length > 0) printDocuments.push(...res);
          invoice.PreparationPrintCount++;
        });
      }
    }
    if (hasSelfPrint) {
      if (printDocuments?.length > 0) {
        if (this.HasLocalPrint) {
          const group = new GroupByPipe();
          const newList = group.transform(
            printDocuments.filter((c) => c.InvoicePrintModel.some((x) => x.LocalServiceIp != null)),
            ["LocalServiceIp"]
          );
          newList?.forEach((element) => {
            if (element?.key && element?.key !== "undefined" && element?.value) {
              const url = "http://" + element.key + "/PrintDocument";
              this.httpCommonService
                .postCustom(url, element?.value)
                .pipe(take(1))
                .subscribe(
                  (data: any) => {},
                  (err) => {}
                );
            }
          });
        }
        let FilterList = printDocuments.filter((c) => c.InvoicePrintModel.some((x) => x.LocalServiceIp === null));
        if (this.currentBranch?.HasLocalService && FilterList?.length > 0 && FilterList.map((c) => c.InvoicePrintModel).length > 0) {
          const url = "http://" + this.currentBranch.LocalServiceIp + "/PrintDocument";
          this.httpCommonService
            .postCustom(url, FilterList)
            .pipe(take(1))
            .subscribe(
              (data: any) => {},
              (err) => {}
            );
        }
      }
    }
    return printDocuments;
  }
  async PrintLocal(invoice: Invoice, hasReturn?: boolean): Promise<PrintDocumentInvoiceModel[]> {
    let printDocuments: PrintDocumentInvoiceModel[] = [];
    let oldStatusCode: number;
    let printTimeCode: number;
    let personals: Personnel[] = [];
    let ids: number[] = [];
    let customerTotalDebit: number = 0;
    if (this.currentBranch?.HasTotalDebit && invoice.Debit === 0 && invoice.CommandCode != InvoiceCommand.Assign) {
      customerTotalDebit = await this.httpCommonService.create("Invoice/GetCredit", invoice).take(1).toPromise();
    }
    if (invoice.Deposit) {
      const array = invoice?.Deposit.DepositPersonnelList?.map((x) => x.PersonnelId);
      ids = array["flat"]();
      let uniqueIds: number[] = ids.reduce((acc, val) => {
        if (!acc.includes(val)) acc.push(val);
        return acc;
      }, []);
      if (uniqueIds && uniqueIds.length > 0)
        personals = await this.httpCommonService.create("Personnel/GetPersonnelByIds", uniqueIds).pipe(take(1)).toPromise();
    }
    const info = this.accountService.authService.currentInformation();
    this.order.indexedDbService.get("FrontOffice", "Categories").then((res) => {
      this.itemCategoryListAll = res[0];
    });
    oldStatusCode = invoice.OldStatusCode;
    let mapper = new MapObjectPipe();
    let Invoiceoutput = new InvoicePrintModel();
    let model: InvoicePrintModel;
    printTimeCode = invoice.PrintPolicyPrintTime;
    model = null;
    model = Object.assign({}, mapper.transform(invoice, Invoiceoutput));
    model.Items = [];
    if (this.order.saleMethodBranch?.ShowDescInvCustomer || this.order.saleMethodBranch?.ShowDescInvKitchen) {
      let descResult = model.Description.split("///");
      if (descResult != null && descResult.length > 0)
        switch (descResult.length) {
          case 1:
            model.DescKitchen = descResult[0];
            model.DescCustomer = "";
            model.Description = "";
            break;
          case 2:
            model.DescKitchen = descResult[0];
            model.DescCustomer = descResult[1];
            model.Description = "";
          case 3:
            model.DescKitchen = descResult[0] + " " + descResult[2];
            model.DescCustomer = descResult[1] + " " + descResult[2];
            model.Description = "";
          default:
            break;
        }
    }
    if (this.currentBranch.FoodTruck) {
      this.tabletPos.tabletPosPrint(invoice, info.BrandName).then(() => {
        const printPolicies = this.PrintPolicy.filter(
          (x) =>
            x.BranchId == this.currentBranch.Id &&
            (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId))
        );
        if (
          invoice.SaleMethodNatureCode !== SaleMethodNature.Delivery &&
          invoice.SaleMethodNatureCode !== SaleMethodNature.Restaurant &&
          printPolicies.length > 1
        ) {
          this.tabletPos.tabletPosPrint(invoice, info.BrandName).then();
        }
      });
      return;
    }
    //بابت چاپ محلی و لوکال سرویس اضاٝه شد
    if (invoice.OtherPrintTemplateId && invoice.PrintPolicyPrintTime === PrintPolicyPrintTimeEnum.CustomerPrint) {
      const printPolicies = this.PrintPolicy.filter(
        (x) =>
          x.NonDefaultPrinting &&
          x.PrintTemplateId == invoice.OtherPrintTemplateId &&
          !x.HasLocalSetting &&
          x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
          x.BranchId == this.currentBranch.Id &&
          (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
          (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
      );
      const printPoliciesLocal = this.PrintPolicy.filter(
        (x) =>
          x.NonDefaultPrinting &&
          x.PrintTemplateId == invoice.OtherPrintTemplateId &&
          ((x.HasLocalSetting && x.ComputerName == this.ComputerName) || this.currentBranch?.HasLocalService) &&
          x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
          x.BranchId == this.currentBranch.Id &&
          (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
          (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
      );
      if (printPolicies.length > 0 && printPoliciesLocal.length <= 0) {
        return;
      }
    }
    if (model.Logo?.length <= 0) model.Logo = null;
    if (!model.NumberOfGuests) model.NumberOfGuests = null;
    if (!model.CustomerNumber) model.CustomerNumber = null;
    invoice.Items.forEach((it) => {
      let InvoiceItemoutput = new InvoiceItemPrintModel();
      model.Items.push(JSON.parse(JSON.stringify(mapper.transform(it, InvoiceItemoutput))));
    });
    let Items: any[] = [];
    let Catogorys: any[] = [];
    if (model.Items.some((a) => a.PrintDisplayOrder > 0)) {
      model.Items = JSON.parse(
        JSON.stringify(
          model.Items.sort(function (a, b) {
            return a.PrintDisplayOrder - b.PrintDisplayOrder;
          })
        )
      );
    } else {
      model.Items = JSON.parse(
        JSON.stringify(
          model.Items.sort(function (a, b) {
            return a.Index - b.Index;
          })
        )
      );
    }
    let row: number = 0;
    model.Items.forEach((item) => {
      row++;
      item.Price = item.UnitPrice * item.Quantity;
      Items.push(item.ItemId);
      if (item.CategoryId && !Catogorys.some((c) => c == item.CategoryId)) {
        Catogorys.push(item.CategoryId);
        if (item?.ParentCategoryId != null) Catogorys.push(item.ParentCategoryId);
      }
      if (model.CurrencyCode == 2) {
        item.UnitPrice = item.UnitPrice / 10;
        item.Price = item.Price / 10;
        item.TotalPrice = item.TotalPrice / 10;
        item.UnitAdditive = item.UnitAdditive / 10;
        item.UnitDiscount = item.UnitDiscount / 10;
        item.UnitToll = item.UnitToll / 10;
        item.UnitService = item.UnitService / 10;
        item.UnitTax = item.UnitTax / 10;
      }
      item.RowNumber = row;
    });
    model.ShippingAddress = invoice.SaleMethodNatureCode == SaleMethodNature.Delivery ? invoice.CustomerAddres : null;
    model.IsBarCodeInvoice = this.order.saleMethodBranch.IsBarCodeInvoice;
    model.ItemCountDisplay = this.order.saleMethodBranch.ItemCountDisplay;
    model.CustomerPhoneNumber = invoice.PhoneNumber;
    model.PrintTime = new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
    if (!model.CreateDate) model.CreateDate = new Date();
    if (PrintPolicyPrintTimeEnum.CustomerPrint == invoice.PrintPolicyPrintTime && invoice.CommandCode != InvoiceCommand.Assign)
      model.RePrint = invoice.CustomerPrintCount >= 1;
    if (PrintPolicyPrintTimeEnum.PreparationPrint == invoice.PrintPolicyPrintTime) model.RePrint = invoice.PreparationPrintCount >= 1;

    model.DisplayLogoInPrintTemplates = this.currentBranch.DisplayLogoInPrintTemplates;
    model.ItemCount = model.Items.length.toString();
    model.DisplayAddressInInvoice = this.currentBranch.DisplayAddressInInvoice;
    model.IgnoreBlackBackground = this.currentBranch.IgnoreBlackBackground;
    model.CurrencyCode = this.currentBranch.CurrencyCode;
    model.CurrencyTitle = this.currentBranch.CurrencyTitle;
    model.RestaurantEconomicalNumber = this.currentBranch.EconomicalNumber;
    model.CustomerEconomicCode = invoice.Customer?.EconomicCode;
    model.RestaurantPhoneNumber = this.currentBranch.PhoneNumber;
    model.IsPickUp = invoice.IsPickUp;
    const itemIds: number[] = invoice.Items.map((x) => x.ItemId);
    model.TotalCalories = this.itemCategoryListAll?.Items.filter((x) => itemIds.includes(x.Id))
      .map((x) => x.Calories)
      .reduce((x, y) => x + y, 0);
    model.RestaurantPostalCode = this.currentBranch.PostalCode;
    model.MultiPhoneNumber = invoice.MultiPhoneNumber;
    model.CreatedDateTime = invoice.CreateDateTime;
    model.PayableAmountToPersian = this.persianService.wordify(model.PayableTotal);
    model.CustomerPostalCode = invoice.Customer?.PostalCode?.toString();
    model.ShippingCost = model.CurrencyCode == 2 ? model.ShippingCost / 10 : model.ShippingCost;
    model.HasTotalDebit = this.currentBranch?.HasTotalDebit;
    if (this.currentBranch?.HasTotalDebit) {
      model.CustomerTotalDebit = model.Debit === 0 && invoice.CommandCode != InvoiceCommand.Assign ? customerTotalDebit : model.CustomerTotalDebit;
    } else model.CustomerTotalDebit = null;
    if (invoice.Deposit) {
      let cookDisplayNames: string[] = [];
      let courierDisplayNames: string[] = [];
      let cooksServicesAmountVariable: string = "";
      let courierServicesAmountVariable: string = "";
      const cooksPersonnel = personals.filter((c) => ids.includes(c.Id) && c.Roles.some((r) => r.PersonnelRole.Code == PersonnelRolesCodeEnum.Cooks));
      const driverPersonnel = personals.filter(
        (c) => ids.includes(c.Id) && c.Roles.some((r) => r.PersonnelRole.Code == PersonnelRolesCodeEnum.Driver)
      );
      if (cooksPersonnel != null) {
        cooksPersonnel.forEach((cook) => {
          if (model.CooksServicesAmount) cooksServicesAmountVariable += cook.Party?.DisplayName;
          else cooksServicesAmountVariable = cook.Party?.DisplayName;
          cookDisplayNames.push(cooksServicesAmountVariable);
        });
        model.CooksServicesAmount = cookDisplayNames.join("-");
      }
      if (driverPersonnel != null) {
        driverPersonnel.forEach((courier) => {
          if (model.CourierServicesAmount) courierServicesAmountVariable += courier.Party?.DisplayName;
          else courierServicesAmountVariable = courier.Party?.DisplayName;
          courierDisplayNames.push(courierServicesAmountVariable);
        });
        model.CourierServicesAmount = courierDisplayNames.join("-");
      }
      model.DeliveryType = DeliveryEnum[invoice.Deposit.DeliveryType];

      model.ServingFoodDate = moment(invoice.Deposit.ServingFoodDate).locale("fa").format("YYYY/MM/DD").toString();
      model.ClearType = ClearEnum[invoice.Deposit.ClearType];
      var servingFoodDateWeekDay = Moment(invoice.Deposit.ServingFoodDate).locale("fa").weekday();
      model.ServingFoodTime = invoice.Deposit.ServingFoodTime;
      model.NumberOfPeople = invoice.Deposit.NumberOfPeople;
      model.MealTimeTitle = MealEnum[invoice.Deposit.MealTime];
      model.DaysOfWeek = this.DataDaysWeek.find((c) => c.Id == servingFoodDateWeekDay).Title;
      model.RemainingAmount =
        model.CurrencyCode == 2 ? (model.PayableTotal - invoice.Deposit.DepositAmount) / 10 : model.PayableTotal - invoice.Deposit.DepositAmount;
      model.RemainingAmountToPersian = this.persianService.wordify(model.RemainingAmount);
      model.ServicesAmount = model.CurrencyCode == 2 ? invoice.Deposit.ServicesAmount / 10 : invoice.Deposit.ServicesAmount;
      model.DepositAmount = model.CurrencyCode == 2 ? invoice.Deposit.DepositAmount / 10 : invoice.Deposit.DepositAmount;
      model.DaysOfWeek = this.DataDaysWeek.find((c) => c.Id == servingFoodDateWeekDay).Title;
    }
    model.CustomerNationalCode = invoice.Customer?.Party?.NationalCode;
    model.BranchNationalCode = this.currentBranch?.NationalCode;
    model.CreatedUserPhoneNumber = this.currentUserPhoneNumber;
    model.CustomerNationalId = invoice.Customer?.Party?.NationalId;
    model.CustomerRegistrationNumber = invoice.Customer?.RegistrationNumber;

    model.RestaurantTitle = info.CustomerName;
    model.RestaurantAddress = info.RestaurantAddress;
    model.Message = this.currentBranch.Message;
    model.OtherPrintTemplateId = invoice.OtherPrintTemplateId;
    model.CustomerNumber = `${model.CustomerNumber}`;
    if (model.CustomerNumber === null || model.CustomerNumber === "null") model.CustomerNumber = "0";
    if (model.CurrencyCode == 2) {
      model.TotalNet = model.TotalNet / 10;
      model.PayableTotal = model.PayableTotal / 10;
      model.TotalService = model.TotalService / 10;
      model.TotalTax = model.TotalTax / 10;
      model.TotalToll = model.TotalToll / 10;
      model.TotalDiscount = model.TotalDiscount / 10;
      model.Total = model.Total / 10;
      model.PackingPrice = model.PackingPrice / 10;
    }
    // let ItemsprintPolicies: PrintPolicy[];
    // let GroupprintPolicies: PrintPolicy[];
    let printPolicies: PrintPolicy[] = [];
    if (!model.OtherPrintTemplateId) {
      if (invoice.PrintPolicyPrintTime == PrintPolicyPrintTimeEnum.CustomerPrint) {
        if (!model.IsReceiptPrint)
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              !x.NonDefaultPrinting &&
              ((x.HasLocalSetting && x.ComputerName === this.ComputerName) || this.currentBranch.HasLocalService) &&
              x.BranchId == this.currentBranch.Id &&
              !x.IsReceiptPrint &&
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
        else
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              !x.NonDefaultPrinting &&
              ((x.HasLocalSetting && x.ComputerName === this.ComputerName) || this.currentBranch.HasLocalService) &&
              x.BranchId == this.currentBranch.Id &&
              x.IsReceiptPrint &&
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
        if (printPolicies?.some((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName))
          printPolicies = printPolicies?.filter((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName);
      } else {
        if (!model.IsMultiPrint)
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              !x.NonDefaultPrinting &&
              !x.IsOrderPrint &&
              x.BranchId == this.currentBranch.Id &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
        else
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              !x.NonDefaultPrinting &&
              x.IsOrderPrint &&
              x.BranchId == this.currentBranch.Id &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
      }
    } else {
      if (invoice.PrintPolicyPrintTime == PrintPolicyPrintTimeEnum.CustomerPrint) {
        if (!model.IsReceiptPrint) {
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              x.NonDefaultPrinting &&
              !x.IsReceiptPrint &&
              x.PrintTemplateId == model.OtherPrintTemplateId &&
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              x.BranchId == this.currentBranch.Id &&
              ((x.HasLocalSetting && x.ComputerName === this.ComputerName) || this.currentBranch.HasLocalService) &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
          if (printPolicies?.some((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName))
            printPolicies = printPolicies?.filter((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName);
          else printPolicies = printPolicies?.filter((x) => !x.HasLocalSetting);
          if (printPolicies.length === 0) {
            printPolicies = this.PrintPolicy.filter(
              (x) =>
                x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
                !x.NonDefaultPrinting &&
                !x.IsReceiptPrint &&
                ((x.HasLocalSetting && x.ComputerName === this.ComputerName) || this.currentBranch.HasLocalService) &&
                x.BranchId == this.currentBranch.Id &&
                (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
                (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
            );
            if (printPolicies?.some((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName))
              printPolicies = printPolicies?.filter((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName);
          }
        } else {
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              x.NonDefaultPrinting &&
              x.IsReceiptPrint &&
              x.PrintTemplateId == model.OtherPrintTemplateId &&
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              x.BranchId == this.currentBranch.Id &&
              ((x.HasLocalSetting && x.ComputerName === this.ComputerName) || this.currentBranch.HasLocalService) &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
          if (printPolicies?.some((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName))
            printPolicies = printPolicies?.filter((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName);
          else printPolicies = printPolicies?.filter((x) => !x.HasLocalSetting);
          if (printPolicies.length === 0) {
            printPolicies = this.PrintPolicy.filter(
              (x) =>
                x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
                !x.NonDefaultPrinting &&
                x.IsReceiptPrint &&
                ((x.HasLocalSetting && x.ComputerName === this.ComputerName) || this.currentBranch.HasLocalService) &&
                x.BranchId == this.currentBranch.Id &&
                (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
                (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
            );
            if (printPolicies?.some((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName))
              printPolicies = printPolicies?.filter((x) => x.HasLocalSetting && x.ComputerName === this.ComputerName);
          }
        }
      } else if (invoice.PrintPolicyPrintTime == PrintPolicyPrintTimeEnum.PreparationPrint) {
        if (!model.IsMultiPrint)
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              !x.IsOrderPrint &&
              x.BranchId == this.currentBranch.Id &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
        else
          printPolicies = this.PrintPolicy.filter(
            (x) =>
              x.PrintTimeCode == invoice.PrintPolicyPrintTime &&
              x.IsOrderPrint &&
              x.BranchId == this.currentBranch.Id &&
              (x.SaleMethodBranches?.length <= 0 || x.SaleMethodBranches?.some((smb) => smb.SaleMethodBranchId == invoice.SaleMethodBranchId)) &&
              (x.Salons?.length <= 0 || x.Salons.some((s) => s.SalonId == invoice.SalonId))
          );
      }
    }
    // if (invoice.CommandCode == InvoiceCommand.ReprintForPreparation) {
    //   printPolicies.forEach((item) => {
    //     if (item?.PrintTemplate?.PrintTemplateTypeCode == PrintTemplateType.Preparation) {
    //       if (item.PrintTemplate.Name.includes("_EN")) {
    //         item.PrintTemplate = this.PrintTemplate.find((w) => w.Name.includes("Sepidz_DELIVERY_MANAGER_EN_ALL"));
    //       } else {
    //         item.PrintTemplate = this.PrintTemplate.find((w) => w.Name.includes("Sepidz_DELIVERY_MANAGER_ALL"));
    //       }
    //     }
    //   });
    // }
    if (printPolicies != null && printPolicies?.length > 0) {
      let Items = Object.assign([], model.Items);
      printPolicies.forEach((item) => {
        if (PrintPolicyPrintTimeEnum.CustomerPrint != invoice.PrintPolicyPrintTime) {
          if (item.Items && item.Items.length > 0 && (!item.Categories || item.Categories.length == 0)) {
            model.Items = Items.filter((x) => item.Items.some((i) => i.ItemId == x.ItemId) && !item.IgnoredItems.some((i) => i.ItemId == x.ItemId));
          } else if ((!item.Items || item.Items.length == 0) && item.Categories && item.Categories.length > 0) {
            model.Items = Items.filter(
              (x) => item.Categories.some((i) => i.ItemCategoryId == x.CategoryId) && !item.IgnoredItems.some((i) => i.ItemId == x.ItemId)
            );
          } else if (item.Items && item.Items.length > 0 && item.Categories && item.Categories.length > 0) {
            model.Items = Items.filter(
              (x) =>
                (item.Categories.some((i) => i.ItemCategoryId == x.CategoryId) && !item.IgnoredItems.some((i) => i.ItemId == x.ItemId)) ||
                (item.Items.some((i) => i.ItemId == x.ItemId) && !item.IgnoredItems.some((i) => i.ItemId == x.ItemId))
            );
          }
        }
        if (item?.Dependents?.length > 0) {
          item?.Dependents?.forEach((dp) => {
            if (!model.DependentPrintPolicyTitles) model.DependentPrintPolicyTitles = dp.DependentPrintPolicy.Title;
          });
        } else {
          model.DependentPrintPolicyTitles = "";
        }
        model.Title = item.Title + "-" + invoice.SaleMethodBranchTitle;
        var allowPrint = true;
        item?.Printers?.forEach((printer) => {
          var printed = false;
          let lists: InvoicePrintModel[] = [];
          if (!printed && invoice.CommandCode === InvoiceCommand.ReprintForPreparation) {
            const final = Object.assign({}, model);
            final.LocalServiceIp = item.LocalServiceIp;
            final.PrintTimeCode = item.PrintTimeCode;
            if (final.Items.length > 0) {
              lists.push(final);
              printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, "Sepidz_DELIVERY_MANAGER_ALL", item.LocalServiceIp));
              printed = true;
            }
          }
          if (
            !printed &&
            item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED" &&
            !model.Items.some((i) => i.NewQuantity > 0) &&
            (oldStatusCode == InvoiceStatus.Pending || model.OldSaleMethodBranchId != null)
          ) {
            const final = Object.assign({}, model);
            final.LocalServiceIp = item.LocalServiceIp;
            final.PrintTimeCode = item.PrintTimeCode;
            if (final.Items.length > 0) {
              lists.push(final);
              printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, "Sepidz_DELIVERY_MANAGER_ALL", item.LocalServiceIp));
              printed = true;
            }
          }
          if (
            (item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED" ||
              item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED_WITH_DIFF") &&
            !model.Items.some((i) => i.NewQuantity > 0) &&
            invoice.CommandCode === InvoiceCommand.Cancel &&
            !printed
          ) {
            const final = Object.assign({}, model);
            final.LocalServiceIp = item.LocalServiceIp;
            final.PrintTimeCode = item.PrintTimeCode;
            if (final.Items.length > 0) {
              lists.push(final);
              printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, "Sepidz_DELIVERY_MANAGER_ALL", item.LocalServiceIp));
              printed = true;
            }
          }
          if (
            !printed &&
            item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED" &&
            model.Items.some((i) => i.NewQuantity < 0) &&
            !model.Items.some((i) => i.NewQuantity > 0) &&
            model.OldSaleMethodBranchId == null
          )
            allowPrint = false;
          if (
            !printed &&
            (item.PrintTemplate.Name != "Sepidz_DELIVERY_MANAGER_MODIFIED" ||
              (invoice.hasChangedTable && model.OldSaleMethodBranchId == null) ||
              invoice.PreparationPrintCount == 1 ||
              (item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED" && model.Items.some((i) => i.NewQuantity > 0)))
          ) {
            if (item.PrintTemplate.Name === "Sepidz_DELIVERY_MANAGER_ALL") {
              model.Items = Object.assign(
                [],
                model.Items.filter((i) => i.Quantity > 0)
              );
            }
            if (
              item.PrintTemplate.Name != "Sepidz_DELIVERY_MANAGER_ALL_WITH_DIFF" &&
              item.PrintTemplate.Name != "Sepidz_DELIVERY_MANAGER_MODIFIED_WITH_DIFF" &&
              allowPrint
            ) {
              model.Items = Object.assign(
                [],
                model.Items.filter((x) => x.State != RowState.Delete && x.State != RowState.SoftDelete)
              );
              if (
                invoice.hasChangedTable &&
                model.OldSaleMethodBranchId == null &&
                !model.Items.some((i) => i.NewQuantity > 0) &&
                printTimeCode == PrintPolicyPrintTimeEnum.PreparationPrint
              ) {
                const final = Object.assign({}, model);
                final.LocalServiceIp = item.LocalServiceIp;
                final.PrintTimeCode = item.PrintTimeCode;
                if (final.Items.length > 0) {
                  lists.push(final);
                  printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, "Sepidz_DELIVERY_MANAGER_ALL", item.LocalServiceIp));
                  printed = true;
                }
              } else {
                if (item.PrintTemplate.Name === "Sepidz_DELIVERY_MANAGER_MODIFIED" && !invoice.hasChangedTable) {
                  model.Items = model.Items.filter((c) => c.NewQuantity > 0);
                }
                const final = Object.assign({}, model);
                final.LocalServiceIp = item.LocalServiceIp;
                final.PrintTimeCode = item.PrintTimeCode;
                if (final.Items.length > 0) {
                  lists.push(final);
                  printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, item.PrintTemplate.Name, item.LocalServiceIp));
                  printed = true;
                }
              }
            } else if (model.OldSaleMethodBranchId && item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED_WITH_DIFF") {
              const final = Object.assign({}, model);
              final.LocalServiceIp = item.LocalServiceIp;
              final.PrintTimeCode = item.PrintTimeCode;
              if (final.Items.length > 0) {
                lists.push(final);
                printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, "Sepidz_DELIVERY_MANAGER_ALL", item.LocalServiceIp));
                printed = true;
              }
            } else if (
              invoice.hasChangedTable &&
              item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED_WITH_DIFF" &&
              !model.Items.some((i) => i.NewQuantity > 0) &&
              printTimeCode == PrintPolicyPrintTimeEnum.PreparationPrint
            ) {
              const final = Object.assign({}, model);
              final.LocalServiceIp = item.LocalServiceIp;
              final.PrintTimeCode = item.PrintTimeCode;
              if (final.Items.length > 0) {
                lists.push(final);
                printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, "Sepidz_DELIVERY_MANAGER_ALL", item.LocalServiceIp));
                printed = true;
              }
            } else {
              if (!printed && allowPrint) {
                if (
                  item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED_WITH_DIFF" ||
                  item.PrintTemplate.Name == "Sepidz_DELIVERY_MANAGER_MODIFIED"
                ) {
                  model.Items = model.Items.filter((c) => c.NewQuantity != 0);
                }
                if (model.Items.length > 0) {
                  const final = Object.assign({}, model);
                  final.LocalServiceIp = item.LocalServiceIp;
                  final.PrintTimeCode = item.PrintTimeCode;
                  lists.push(final);
                  printDocuments.push(new PrintDocumentInvoiceModel(lists, printer.Name, item.PrintTemplate.Name, item.LocalServiceIp));
                }
              }
            }
          }
        });
      });
    }
    return printDocuments;
  }
  async printDescription(model: Invoice): Promise<PrintDocumentInvoiceModel[]> {
    let printDocuments: PrintDocumentInvoiceModel[] = [];
    if (model.CommandCode === InvoiceCommand.TemporaryRegister || model.CommandCode === InvoiceCommand.Save) return;
    var HasPrintDescription = false;
    if (model.OldSaleMethodBranchId != null) {
      HasPrintDescription = true;
    }
    if (model.StatusCode == InvoiceStatus.Cancelled) {
      if (model.PrintDescription) {
        model.PrintDescription += `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.InvoiceNumber")} ${
          model.NumberingInDate
        } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.SaleMethod")} ${model.SaleMethodBranchTitle} ${this.translate(
          "ClientApp.FrontOffice.Order.Providers.InvoicePrint.Canceled"
        )}`;
      } else {
        model.PrintDescription = `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.InvoiceNumber")} ${
          model.NumberingInDate
        } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.SaleMethod")} ${model.SaleMethodBranchTitle} ${this.translate(
          "ClientApp.FrontOffice.Order.Providers.InvoicePrint.Canceled"
        )}`;
      }
      HasPrintDescription = true;
    }
    if (model.StatusCode == InvoiceStatus.Deleted) {
      if (model.PrintDescription) {
        model.PrintDescription += `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.InvoiceNumber")} ${
          model.NumberingInDate
        } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.SaleMethod")} ${model.SaleMethodBranchTitle} ${this.translate(
          "ClientApp.FrontOffice.Order.Providers.InvoicePrint.Deleted"
        )}`;
      } else {
        model.PrintDescription = `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.InvoiceNumber")} ${
          model.NumberingInDate
        } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoicePrint.SaleMethod")} ${model.SaleMethodBranchTitle} ${this.translate(
          "ClientApp.FrontOffice.Order.Providers.InvoicePrint.Deleted"
        )}`;
      }
      HasPrintDescription = true;
    }
    if (model.PrintDescription && HasPrintDescription) {
      let InvoiceList: Invoice[] = [];
      const invoiceModel = Object.assign({}, model);
      invoiceModel.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.PreparationPrint;
      await this.PrintLocal(invoiceModel).then((res) => {
        printDocuments = res;
      });
    }
    if (printDocuments?.length > 0) {
      if (this.HasLocalPrint) {
        const group = new GroupByPipe();
        const newList = group.transform(
          printDocuments.filter((c) => c.InvoicePrintModel.some((x) => x.LocalServiceIp != null)),
          ["LocalServiceIp"]
        );
        newList?.forEach((element) => {
          if (element?.key && element?.key !== "undefined" && element?.value) {
            const url = "http://" + element.key + "/PrintDocument";
            this.httpCommonService
              .postCustom(url, element?.value)
              .pipe(take(1))
              .subscribe(
                (data: any) => {},
                (err) => {}
              );
          }
        });
      }
      let FilterList = printDocuments.filter((c) => c.InvoicePrintModel.some((x) => x.LocalServiceIp === null));
      if (this.currentBranch?.HasLocalService && FilterList?.length > 0 && FilterList.map((c) => c.InvoicePrintModel).length > 0) {
        const url = "http://" + this.currentBranch.LocalServiceIp + "/PrintDocument";
        this.httpCommonService
          .postCustom(url, FilterList)
          .pipe(take(1))
          .subscribe(
            (data: any) => {},
            (err) => {}
          );
      }
    }
    return printDocuments;
  }
}
